
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import html2pdf from "html2pdf.js";
import toast from "react-hot-toast";
import AppointmentTemplate from "../../Components/Template/AppointmentTemplate";
import { Ctnbtn, previewbtn } from "../../Assets/CSS/Button";

const AppointmentLetter = ({ empData }) => {
    const editorRef = useRef(null);
    const [isManagerApproved, setIsManagerApproved] = useState(false);

    const [sendingManager, setSendingManager] = useState(false);
    const [sendingEmployee, setSendingEmployee] = useState(false);

    const [salaryData, setSalaryData] = useState(null);
    const [editorData, setEditorData] = useState("");
    const [isPreview, setIsPreview] = useState(true);
    const [loading, setLoading] = useState(false);

    const employeeId = empData?.potentialEmployeeId;



    // ==============fetch satus of Appoved status for Appointment============
    useEffect(() => {
        if (!salaryData) return;

        setIsManagerApproved(salaryData?.fileStatus === "APPROVED");
    }, [salaryData]);




    /* ================= FETCH DATA ================= */
    useEffect(() => {
        if (!employeeId) return;

        const fetchSalaryData = async () => {
            try {
                setLoading(true);
                const token = localStorage.getItem("token");

                const res = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/v1/potential-employees/${employeeId}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                setSalaryData(res.data);
            } catch (err) {
                toast.error("Failed to load employee data");
            } finally {
                setLoading(false);
            }
        };

        fetchSalaryData();
    }, [employeeId]);

    /* ================= BUILD TEMPLATE ================= */
    useEffect(() => {
        if (!salaryData) return;

        const salaryComponents =
            salaryData.salaryComponents
                ? Object.entries(salaryData.salaryComponents).map(
                    ([name, annual]) => ({
                        name,
                        annual,
                        monthly: Math.round(annual / 12),
                    })
                )
                : [];

        const html = AppointmentTemplate({
            tenantName: salaryData.tenantName,
            companyAddress: `${salaryData.tenantAddress.streetLine1},
        ${salaryData.tenantAddress.city},
        ${salaryData.tenantAddress.state} - ${salaryData.tenantAddress.postalCode}`,
            companyContact: salaryData.tenantMobileNumber,
            currentdate: new Date().toLocaleDateString(),
            employeeName: salaryData.empName,
            designation: salaryData.designation,
            joiningDate: salaryData.dateOfJoining,
            ManagerName: salaryData.managerName,
            salaryComponents,
            totalCTC: salaryData.ctcOfEmployee,
        });

        setEditorData(html);
    }, [salaryData]);

    /* ================= TOGGLE PREVIEW ================= */
    const togglePreview = () => {
        const next = !isPreview;
        setIsPreview(next);

        if (editorRef.current) {
            if (next) {
                editorRef.current.enableReadOnlyMode("preview");
            } else {
                editorRef.current.disableReadOnlyMode("preview");
            }
        }
    };

    /* ================= PDF GENERATION ================= */
    // const generatePDFBlob = async () => {
    //     const element = document.getElementById("offer-preview");

    //     return html2pdf()
    //         .set({
    //             margin: 10,
    //             image: { type: "jpeg", quality: 0.98 },
    //             html2canvas: { scale: 2, backgroundColor: "#fff" },
    //             jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    //         })
    //         .from(element)
    //         .outputPdf("blob");
    // };
    const generatePDFBlob = async () => {
        const source = document.getElementById("offer-preview");

        if (!source) throw new Error("Preview content not found");

        // Clone content
        const clone = source.cloneNode(true);

        // FIX WIDTH & OVERFLOW
        clone.style.width = "794px";           // A4 width
        clone.style.maxWidth = "794px";
        clone.style.height = "auto";
        clone.style.maxHeight = "none";
        clone.style.overflow = "visible";
        clone.style.boxSizing = "border-box";
        clone.style.padding = "20px";
        clone.style.background = "#fff";

        // Wrapper
        const wrapper = document.createElement("div");
        wrapper.style.position = "fixed";
        wrapper.style.top = "-99999px";
        wrapper.style.left = "0";
        wrapper.style.width = "794px";
        wrapper.style.background = "#fff";
        wrapper.appendChild(clone);

        document.body.appendChild(wrapper);

        await document.fonts.ready;
        await new Promise((r) => setTimeout(r, 200));

        const pdfBlob = await html2pdf()
            .set({
                margin: 10,
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: {
                    scale: 1,
                    width: 794,
                    windowWidth: 794,
                    backgroundColor: "#ffffff",
                },
                jsPDF: {
                    unit: "mm",
                    format: "a4",
                    orientation: "portrait",
                },
            })
            .from(clone)
            .outputPdf("blob");

        document.body.removeChild(wrapper);

        return pdfBlob;
    };



    /* ================= VIEW PDF ================= */
    const viewPDF = async () => {
        if (!isPreview) togglePreview();
        await new Promise((r) => setTimeout(r, 300));

        const blob = await generatePDFBlob();
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
    };

    /* ================= SEND TO MANAGER ================= */
    const handleSubmit = async () => {
        // let pdfTab = window.open("", "_blank");

        try {
            setSendingManager(true);

            if (!isPreview) {
                togglePreview();
                await new Promise((r) => setTimeout(r, 300));
            }

            const pdfBlob = await generatePDFBlob();
            const pdfFile = new File([pdfBlob], "Appointment_Letter.pdf", {
                type: "application/pdf",
            });

            const formData = new FormData();
            formData.append("file", pdfFile);
            formData.append("employeeId", employeeId);

            const token = localStorage.getItem("token");

            await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/documents/appointment-letter/${employeeId}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            // const url = URL.createObjectURL(pdfBlob);
            // pdfTab.location.href = url;

            toast.success("Appointment letter sent successfully");
        } catch (err) {
            // pdfTab?.close();
            toast.error("Failed to send appointment letter");
        } finally {
            setSendingManager(false);
        }
    };

    // send to Employee
    const handleSendEmployee = async () => {
        // let pdfTab = window.open("", "_blank");
        try {
            setSendingEmployee(true);

            if (!isPreview) {
                togglePreview();
                await new Promise((r) => setTimeout(r, 300));
            }

            const pdfBlob = await generatePDFBlob();
            const pdfFile = new File([pdfBlob], "Appointment_Letter.pdf", {
                type: "application/pdf",
            });

            const formData = new FormData();
            formData.append("file", pdfFile);
            formData.append("employeeId", employeeId);

            const token = localStorage.getItem("token");

            await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/documents/employee/${employeeId}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            // const url = URL.createObjectURL(pdfBlob);
            // pdfTab.location.href = url;

            toast.success("Appointment letter sent to Employee successfully");
        } catch (err) {
            // pdfTab?.close();
            toast.error("Failed to send appointment letter");
        } finally {
            setSendingEmployee(false);
        }
    };

    /* ================= UI ================= */
    return (
        <div className="container py-0">
            <h5>Generate Appointment Letter</h5>

            {/* <div className="preview-container">
                <CKEditor
                    editor={ClassicEditor}
                    data={editorData}
                    onReady={(editor) => {
                        editorRef.current = editor;
                        editor.enableReadOnlyMode("preview");
                    }}
                    onChange={(event, editor) => {
                        if (!isPreview) setEditorData(editor.getData());
                    }}
                />
            </div> */}
            {/* EDIT MODE */}
            {!isPreview && (
                <CKEditor
                    editor={ClassicEditor}
                    data={editorData}
                    // onReady={(editor) => {
                    //     editorRef.current = editor;
                    // }}
                    onReady={(editor) => {
                        editorRef.current = editor;

                        if (isPreview) {
                            editor.enableReadOnlyMode("preview");
                        }
                    }}
                    // onChange={(event, editor) => {
                    //     setEditorData(editor.getData());
                    // }}
                    onChange={(event, editor) => {
                        if (!isPreview) {
                            setEditorData(editor.getData());
                        }
                    }}
                />
            )}

            {/* PREVIEW MODE (PURE HTML) */}
            {isPreview && (
                <div
                    id="offer-preview"
                    className="preview-container"
                    dangerouslySetInnerHTML={{ __html: editorData }}
                />
            )}


            {/* Hidden PDF container */}
            <div
                id="pdf-content"
                style={{ position: "fixed", top: "-9999px", width: "794px" }}
                dangerouslySetInnerHTML={{ __html: editorData }}
            />

            <div className="d-flex gap-3 mt-4">
                <button className="mt-4 px-4 mb-3" onClick={togglePreview} style={previewbtn}>
                    {isPreview ? "Edit Letter" : "Preview Letter"}
                </button>

                <button className="mt-4 px-4 mb-3" onClick={viewPDF} style={previewbtn}>View PDF</button>

                <button
                    type="button"
                    onClick={handleSubmit} disabled={sendingManager}
                    className=" mt-4 px-4 mb-3  continue-btn" style={Ctnbtn}>
                    {sendingManager ? "Sending..." : "Send to Manager"}
                </button>
                {/* <button type="button"
                    onClick={handleSendEmployee} disabled={sendingEmployee} className=" mt-4 px-4 mb-3  continue-btn" style={Ctnbtn}>
                    {sendingEmployee ? "Sending..." : "Send to Employee"}
                </button> */}
                <button
                    type="button"
                    onClick={handleSendEmployee}
                    disabled={sendingEmployee || !isManagerApproved}
                    className="mt-4 px-4 mb-3"
                    style={{
                        ...Ctnbtn,
                        cursor: sendingEmployee || !isManagerApproved ? "not-allowed" : "pointer",
                        opacity: sendingEmployee || !isManagerApproved ? 0.6 : 1
                    }}
                >
                    {!isManagerApproved
                        ? "Waiting Manager Approval"
                        : sendingEmployee
                            ? "Sending..."
                            : "Send to Employee"}
                </button>

            </div>
        </div>
    );
};

export default AppointmentLetter;
